import React, { useEffect, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
const META_PIXEL_SCRIPT = `
!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '1805230060436087');
fbq('track', 'PageView');
`;
export function App() {
  useEffect(() => {
    // Also fire PageView via JS in case the inline script races
    const w = window as any;
    if (w.fbq) {
      w.fbq('track', 'PageView');
    }
  }, []);
  return <>
      {/* Facebook Pixel - rendered directly into the DOM */}
      <script dangerouslySetInnerHTML={{
      __html: META_PIXEL_SCRIPT
    }} data-id="element-0" />
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1805230060436087&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>
      <LandingPage data-id="element-3" />
    </>;
}